import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setGuest } from '../utils/guest';

const LandingPage = ({ user, setUser, setActiveRole }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white text-black flex flex-col items-center justify-center px-6 py-16 font-mono">
      <div className="w-full max-w-2xl border border-black p-8 text-center">
        <h1 className="text-4xl sm:text-5xl font-bold uppercase mb-4 tracking-wide leading-tight">
          {t('landing.headline')}
        </h1>

        <p className="text-md sm:text-lg text-gray-700 mb-4 tracking-wide">
          {t('landing.subheading')}
        </p>

        <div className="border-t border-black my-4" />

        <p className="text-base sm:text-lg mb-8 text-gray-900 leading-relaxed">
          {t('landing.description')}
        </p>

        <button
          onClick={() => {
            setGuest(true);
            navigate('/student-dashboard');
          }}
          className="border border-black bg-white text-black px-6 py-3 font-bold uppercase tracking-wide hover:bg-black hover:text-white transition-all duration-200"
        >
         {t('landing.entryButton')}
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
